import { TransportOrderIdView } from '../../../../models';

export class ShipmentTransportOrderStatusHistoryLoad {
  public static readonly type = '[ShipmentTransportOrderStatusHistory] Load';
  constructor(public payload: TransportOrderIdView) {}
}

export class ShipmentTransportOrderStatusHistorySetInitialState {
  public static readonly type = '[ShipmentTransportOrderStatusHistory] Set Initial State';
}
